// Module
var code = "<div id=\"V-0C58C6EC-98B4-4D9D-9730-7545D620C602\" data-b-content=\"{Binding internalContent,ViewSelector:templateSelector}\"> </div> ";
// Exports
export default code;